
import "./footer.css";
export function FreshCartFooter(){
    return(
        <div className="container-fluid">
            <div className="row footer">
                <div className="col-6 col-sm-6 col-lg-2">
                    <h4>Categories</h4>
                    <div className="d-flex flex-column">
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Breakfast & instant food</a>
                    <a href="">Bakery & Biscuits</a>
                    <a href="">Atta, rice & dal</a>
                    <a href="">Sauces & spreads</a>
                    <a href="">Organic & gourmet</a>
                    <a href="">Baby care</a>
                    <a href="">Cleaning essentials</a>
                    <a href="">Personal care</a>
                    </div>
                </div>
                <div className="col-6 col-sm-6 col-lg-2">
                    <h4></h4>
                    <div className="d-flex flex-column mt-4" >
                    <a href="">Dairy, bread & eggs</a>
                    <a href="">Cold drinks & juices</a>
                    <a href="">Tea, coffee & drinks</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    </div>  
                </div>

                <div className="col-6 col-sm-6 col-lg-2 ">
                    <h4>Get to know us</h4>
                    <div className="d-flex flex-column">
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    </div>
                </div>

                <div className="col-6 col-sm-6 col-lg-2 ">
                    <h4>For Consumers</h4>
                    <div className="d-flex flex-column">
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    </div>
                </div>

                <div className="col-6 col-sm-6 col-lg-2 ">
                    <h4>Become a Shopper</h4>
                    <div className="d-flex flex-column">
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    </div>
                </div>

                <div className="col-6 col-sm-6 col-lg-2 ">
                    <h4>Freshcart programs</h4>
                    <div className="d-flex flex-column">
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    <a href="">Vegetables & Fruits</a>
                    </div>
                </div>  

              <div className="mt-4 row border border-1 ">
              <div className="col-12 col-sm-6 col-lg-6 text-center payment ">
                    <h6>Payment Partners</h6>
                    <div className="d-flex justify-content-center">
                       
                       <img src="1stcart/payment/amazonpay.png" width="60" height="30"/>
                       <img src="1stcart/payment/american-express.png" width="60" height="30"/>
                       <img src="1stcart/payment/MasterCard.png" width="60" height="30"/>
                       <img src="1stcart/category/category-baby-care.jpg" width="60" height="30"/>
                       <img src="1stcart/payment/VISA.png" width="60" height="30"/>
                    </div>
                    
                </div>

                <div className="col-12 col-sm-6 col-lg-6 playstore">
                    <h6 className="d-flex justify-content-center align-items-center">Get deliveries with FreshCart</h6>
                    <div className="d-flex justify-content-center">
                    <img src="1stcart/payment/playstote.png" width="200" className="ms-4" height="50"/>
                    <img src="1stcart/payment/playstote.png" width="200" height="50"/>
                    </div> 
                </div>
              </div>

              <div className="row text-center mt-4">
                
              <div className="col-12 col-12 col-lg-6">
                <p>© 2025 FreshCart TailwindCSS eCommerce HTML Template. Powered by Codescandy .</p>
              </div>
              <div className="col-12 col-12 col-lg-6 last-footer">
                <span className="me-2">Follow us on</span>
                <span className="bi bi-facebook ms-2"></span>
                <span className="bi bi-youtube ms-2"></span>
                <span className="bi bi-instagram ms-2"></span>

              </div>
              </div>
            </div>
        </div>
    )
}